import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import { ApolloProvider } from "@apollo/client";
import { BrowserRouter } from "react-router-dom";

import GraphQlService from "./libs/GraphQlService";

import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";


Sentry.init({
  dsn: "https://5985f24921e146fcb3b0be36637e54cd@o4504735990022144.ingest.sentry.io/4504735991332864",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.5,
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={GraphQlService}>
        <App />
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
